module.exports = __webpack_public_path__ + "static/media/Icons_delete.1c366432.svg";